import { IChartProps, LineChart } from "@fluentui/react-charting";
import ChartHelper from "../../../utils/common/ChartHelper";
import { findMinValue } from "../../../utils/common/CommonHelperFunctions";

export interface CustomLineChartProps {
  chartData: any[];
  onDataPointClick?: any;
  resourceType: string;
  xAxisTickCount?: number;
  customDateTimeFormatter?: any;
  hideLegend?: boolean;
  onLegendClick?: any;
}

export const CustomLineChart: React.FunctionComponent<CustomLineChartProps> = (
  props: CustomLineChartProps
) => {
  const data: IChartProps = {
    chartTitle: "Line Chart",
    lineChartData: ChartHelper.getLineChartData(
      props.chartData,
      props.resourceType,
      props.onLegendClick
    ),
  };

  ChartHelper.setDataPointClick(data, props);
  const margins = { top: 40, bottom: 35, left: 40, right: 30 };

  const minValue = findMinValue(props.chartData[0]?.timeseriesData);
  const yMinValue = minValue < 0 ? Math.floor(minValue - 1) : 0;

  return (
    <div data-testid="lineChart" className="lineChart">
      {props.chartData.length > 0 && (
        <LineChart
          culture={window.navigator.language}
          data={data}
          height={200}
          margins={margins}
          xAxisTickCount={props.xAxisTickCount}
          customDateTimeFormatter={props.customDateTimeFormatter}
          hideLegend={props.hideLegend ? props.hideLegend : false}
          yMinValue={yMinValue}
        />
      )}
    </div>
  );
};
